import { ScoreDescription } from "../../types";

interface ScoreDescriptionsProps {
  scoreDescriptions: [ScoreDescription];
}

const ScoreDescriptions: React.FC<ScoreDescriptionsProps> = ({
  scoreDescriptions,
}) => {
  return (
    <div
      id="w-node-_3b32867a-de79-4d5f-10ab-d0663b4295df-38e776aa"
      className="w-layout-layout quick-stack-4 wf-layout-layout scoreDescription-mainBox"
    >
      {scoreDescriptions.map((sd) => (
        <div
          id="w-node-_3b32867a-de79-4d5f-10ab-d0663b4295e0-38e776aa"
          className="w-layout-cell"
          key={sd.score}
        >
          <div className="score-div"></div>
          <a href="#" className="score-number w-button">
            {sd.score}
          </a>
          <p className="small-text">{sd.description}</p>
        </div>
      ))}
    </div>
  );
};

export default ScoreDescriptions;
